import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class AuthNativeService {

  constructor() { }

  public getAuthToken(): string | null {
    const token = localStorage.getItem('smartApp.authtoken');
    return token ? this.trim(token, '"') : token;
  }

  private trim(str: string, ch: string): string {
    var start = 0,
      end = str.length;

    while (start < end && str[start] === ch)
      ++start;

    while (end > start && str[end - 1] === ch)
      --end;

    return (start > 0 || end < str.length) ? str.substring(start, end) : str;
  }
}
